import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';

import { FormProvider, useForm } from 'react-hook-form';
import Moment from 'moment';
import {
  DialogContent,
  DialogActions,
  FormHelperText,
  Grid as MuiGrid,
} from '@mui/material';
import { withStyles } from '@mui/styles';

// helpers
import * as Yup from 'yup';
import { useSnackbar } from 'notistack';

import { useQueryClient } from '@tanstack/react-query';
import { updateNeedBy } from '../../console/agencies/_services/quotes.service';

// componenets
import CbButton from '../Buttons/CbButton';
import { TextFieldBase } from '../inputs/TextFieldBase';
import { withFormController } from '../hocs/forms';
import { queries } from '../../queries';
import { manageAPIError } from '../../utils';

const TextField = withFormController(TextFieldBase);
const styles = ({ palette, config }) => {
  return {
    header: {
      marginBottom: '1.25rem',
      fontSize: config.textSizes.primer,
      color: palette.primary.contrastText,
    },
    divider: {
      marginBottom: '1.25rem',
    },
    select: {
      justifyContent: 'left',
      '&:focus': {
        borderRadius: 5,
      },
    },
    selectIcon: {
      top: '50%',
      transform: 'translateY(-50%)',
    },
    label: {
      padding: 0,
      fontSize: config.textSizes.normal,
    },
    requiredIcon: {
      color: '#f95f53',
      fontSize: '1.25rem',
      lineHeight: '1rem',
    },
  };
};

const schema = Yup.object().shape({});

export const NeedBy = withStyles(styles)(({ close, data }) => {
  const [error, setError] = useState('');
  const { enqueueSnackbar } = useSnackbar();

  const queryClient = useQueryClient();

  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    register,
    watch,
    formState: { isSubmitting },
    ...methods
  } = useForm({
    defaultValues: {
      needByDate:
        Moment.utc(data.needByDate).format('YYYY-MM-DD') ||
        Moment().add('days', 7).format('YYYY-MM-DD'),
    },
    resolver: yupResolver(schema),
  });

  const onSubmit = (formData) => {
    const date = formData.needByDate
      ? Moment(formData.needByDate).format('YYYY-MM-DD')
      : '';

    return updateNeedBy({ id: data.id, date })
      .then(() => {
        close();
        enqueueSnackbar(`Quote NeedBy Saved Successfully!`, {
          variant: 'success',
        });

        queryClient.invalidateQueries(queries.quotes.list._def);
        queryClient.invalidateQueries(
          queries.quotes.detail(data.id, data.product).queryKey
        );
      })
      .catch((error) => {
        setError(
          manageAPIError(error, 'Something went wrong. Please try again later')
        );
      });
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent className="modal-title" style={{ textAlign: 'left' }}>
          <MuiGrid container spacing={2} justifyContent="center">
            <MuiGrid item md={12}>
              Select a date
            </MuiGrid>
            <MuiGrid item md={12} style={{ marginTop: -10 }}>
              <TextField
                type="date"
                InputProps={{
                  inputProps: { min: Moment().format('YYYY-MM-DD') },
                }}
                name="needByDate"
                controllerProps={{ control }}
              />
            </MuiGrid>
          </MuiGrid>

          {error && (
            <FormHelperText className="api-text-error">{error}</FormHelperText>
          )}
        </DialogContent>
        <DialogActions>
          <CbButton styleName="cancel" onClick={close} buttonText="Cancel" />
          <CbButton
            type="submit"
            styleName="ctaButton"
            buttonText="Save"
            loading={isSubmitting}
            disabled={isSubmitting}
          />
        </DialogActions>
      </form>
    </FormProvider>
  );
});

export default NeedBy;
